import { useEffect, useState } from 'react';

export default function LicenseExpired() {
  const [tenantId, setTenantId] = useState<string | null>(null);

  useEffect(() => {
    const apiUrl = import.meta.env.VITE_API_URL || 'https://sign.virtue.dk';
    fetch(`${apiUrl}/api/auth/me`, { credentials: 'include' })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setTenantId(data.data.tenantId);
        }
      })
      .catch((error) => console.error('Failed to get tenant:', error));
  }, []);

  const handleUpgrade = async () => {
    if (!tenantId) {
      alert('Unable to get tenant information. Please try again.');
      return;
    }

    try {
      const apiUrl = import.meta.env.VITE_API_URL || 'https://sign.virtue.dk';
      const response = await fetch(`${apiUrl}/api/license/create-checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ tenantId }),
      });
      const data = await response.json();
      if (data.success) {
        window.location.href = data.data.url;
      } else {
        alert('Failed to create checkout session: ' + (data.message || 'Unknown error'));
      }
    } catch (error) {
      console.error('Checkout error:', error);
      alert('Failed to initiate checkout. Please try again.');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f9fafb',
      padding: '20px',
    }}>
      <div style={{
        maxWidth: '500px',
        background: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '64px', marginBottom: '20px' }}>⏰</div>
        
        <h1 style={{ 
          margin: '0 0 10px', 
          fontSize: '28px', 
          fontWeight: '700',
          color: '#1f2937',
        }}>
          License Expired
        </h1>
        
        <p style={{ 
          color: '#6b7280', 
          fontSize: '16px',
          margin: '0 0 30px',
          lineHeight: '1.6',
        }}>
          Your VirtueSign trial or subscription has expired. To continue managing email signatures, please upgrade your account.
        </p>

        <div style={{
          background: '#fef3c7',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '30px',
          border: '2px solid #f59e0b',
        }}>
          <div style={{ fontSize: '14px', color: '#92400e', fontWeight: '600', marginBottom: '10px' }}>
            💰 Simple Pricing
          </div>
          <div style={{ fontSize: '13px', color: '#78350f', lineHeight: '1.5' }}>
            • 0-100 users: <strong>100 DKK/month</strong><br />
            • 101+ users: <strong>1 DKK per user/month</strong>
          </div>
        </div>

        <button
          onClick={handleUpgrade}
          style={{
            width: '100%',
            padding: '12px 24px',
            background: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            marginBottom: '15px',
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#5568d3'}
          onMouseLeave={(e) => e.currentTarget.style.background = '#667eea'}
        >
          Upgrade Now
        </button>

        <div style={{ fontSize: '13px', color: '#9ca3af' }}>
          Need help? Contact us at{' '}
          <a href="mailto:support@virtue.dk" style={{ color: '#667eea', textDecoration: 'none' }}>
            support@virtue.dk
          </a>
        </div>
      </div>
    </div>
  );
}
